import React, { useRef, useState, useEffect } from "react";
import {
  initializeChatHub,
  joinChatRoom,
  sendMessage,
  onReceiveMessage,
  leaveChatRoom,
  onReceiveSOS,
  sendSOSAlert,
  markAsRead,
  onReceiveReadReceipt,
  offReceiveReadReceipt,
  onReceiveCallInvite,
  offReceiveCallInvite,
  onReceiveCallEnded,
  offReceiveCallEnded,
} from "../../../../../Service/signalRService";
import { useNotifications } from "Components/Notification/NotificationContext";
import {
  Box,
  Avatar,
  Typography,
  IconButton,
  InputBase,
  Paper,
  Button,
  Modal,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  DialogActions,
  alpha,
  Stack,
} from "@mui/material";
import {
  MoreVert,
  AttachFile,
  Mic,
  Send,
  DeleteForeverRounded,
  CurrencyRupee,
  Campaign,
  Call,
} from "@mui/icons-material";
import { CaseListType } from "DataTypes/Case.type";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { SingleMessageType } from "DataTypes/Chat.type";
import ImgPath from "Constants/Imgs";
import ChatApi from "Service/Chat.api";
import notificationApi from "Service/Notification.api";
import AdminApi from "Service/Admin.api";
import { msgFormatter } from "./Formatter";
import NoData from "Components/NoData";
import dayjs from "dayjs";
import AudioComponent from "./AudioComponent";
import AttachmentComponent from "./AttachmentComponent";
import { MeetingApi } from "Service/Meeting.api";
import { useDispatch } from "react-redux";
import {
  setAlertData,
  startLoading,
  stopLoading,
} from "../../../../../Redux/Screen/Action";
import { FormDataType } from "DataTypes/Form";
import { MeetingCreationFormArr } from "./Data";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { HandleFormChange, MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB, ValidateFormData, formatUserType } from "Utils/Common";
import StatusUpdateModal from "Components/StatusUpdateModal";
import StatusApi from "Service/Status.api";
import ReportIcon from "@mui/icons-material/Report";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaymentApi from "Service/Payment.api";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useSearchParams } from "react-router-dom";
import AgoraCall from "Components/Conference/AgoraCall";
export interface SingleChatPropType {
  selectedCase: CaseListType | null;
}

// Outside the component or as a ref to prevent re-creation
const sosSound = new Audio("/Assets/audio/siren.mp3");
const ringtoneSound = new Audio("/Assets/audio/notification-alert.mp3"); // Using notification alert as requested

const SingleChatScreen1 = (props: SingleChatPropType) => {
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const dispatch = useDispatch();
  const { selectedCase } = props;
  const [input, setInput] = useState("");
  const [openModal, setOpenMoadal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [messages, setMessages] = useState<SingleMessageType[]>([]);
  const [formData, setFormData] = useState<FormDataType[]>([]);
  const [selectedDocument, setSelectedDocument] = useState<{
    url: string | null;
    docType: "video" | "image" | null;
  }>({
    url: null,
    docType: null,
  });
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [recordingChunks, setRecordingChunks] = useState<Blob[]>([]);
  const [recordedAudioUrl, setRecordedAudioUrl] = useState<string | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  const [agoraCallData, setAgoraCallData] = useState<{
    open: boolean;
    appId: string;
    channelName: string;
    token: string;
    uid: number;
    messageId?: number;
    participants: any[];
  }>({
    open: false,
    appId: "",
    channelName: "",
    token: "",
    uid: 0,
    participants: []
  });
  const [analyserNode, setAnalyserNode] = useState<AnalyserNode | null>(null);
  const caseId = selectedCase?.caseId;

  // --- Sync Read Status ---
  useEffect(() => {
    if (caseId) {
      console.log("caseId", caseId);
      // 1. Mark as Read in Backend (Notifications)
      notificationApi.markCaseNotificationsAsRead(Number(caseId))
        .catch((error: any) => {
          console.error("Failed to mark notifications as read", error);
        });

      // 1.1 Mark Messages as Read (Chat Flags)
      ChatApi.markMessagesAsRead({ caseId: Number(caseId) })
        .catch((error: any) => {
          console.error("Failed to mark messages as read", error);
        });

      // 2. Update LocalStorage (for Topbar Badge)
      const saved = localStorage.getItem("unread_notifications");
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          // Filter out notifications for the current case
          const updated = parsed.filter((n: any) => Number(n.caseId) !== Number(caseId));
          localStorage.setItem("unread_notifications", JSON.stringify(updated));

          // 3. Trigger UI Update
          window.dispatchEvent(new Event("notificationsUpdated"));
        } catch (e) {
          console.error("Error updating local notifications", e);
        }
      }
    }
  }, [caseId]);
  const senderUserId = myInfo?.id;
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [caseStatus, setCaseStatus] = useState<any[]>([])
  const scrollRef = React.useRef<HTMLDivElement | null>(null);
  // 1. Add these states at the top of your component
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [baseAmount, setBaseAmount] = useState("");
  const [isGeneratingLink, setIsGeneratingLink] = useState(false);
  // const [searchParams] = useSearchParams();

  const { setActiveCaseId, markCaseNotificationsAsRead } = useNotifications();

  // Synchronize active case with NotificationContext to auto-read incoming messages
  // Synchronize active case with NotificationContext to auto-read incoming messages
  useEffect(() => {
    if (caseId && setActiveCaseId) {
      const numericCaseId = Number(caseId);
      setActiveCaseId(numericCaseId);

      // Also mark existing ones as read immediately
      if (markCaseNotificationsAsRead) {
        markCaseNotificationsAsRead(numericCaseId);
      }
    }
    return () => {
      if (setActiveCaseId) setActiveCaseId(null);
    };
  }, [caseId, setActiveCaseId, markCaseNotificationsAsRead]);
  // const [activeCaseId, setActiveCaseId] = useState<number | null>(null);

  //   useEffect(() => {
  //     console.log("selectedCase?.caseId in index1", selectedCase);
  //   if (selectedCase?.caseId) {
  //     const saved = localStorage.getItem("unread_notifications");
  //     if (saved) {
  //       const notifications = JSON.parse(saved);
  //       const filtered = notifications.filter((n: any) => n.caseId !== selectedCase.caseId);
  //       localStorage.setItem("unread_notifications", JSON.stringify(filtered));
  //       window.dispatchEvent(new Event("notificationsUpdated"));
  //     }
  //       handleFetchChatHistory();
  //       handleInitialLoad();
  //   }
  // }, [selectedCase?.caseId]);

  // Inside SingleChatScreen1 component



  useEffect(() => {
    if (!caseId || !senderUserId) return;
    const token = localStorage.getItem("token") || "";

    if (caseId) {
      // 1. Get existing notifications from localStorage
      const saved = localStorage.getItem("unread_notifications");
      if (saved) {
        const notifications = JSON.parse(saved);

        // 2. Filter out any notifications matching the current caseId
        const filtered = notifications.filter((n: any) => n.caseId !== Number(caseId));

        // 3. Save back to localStorage
        localStorage.setItem("unread_notifications", JSON.stringify(filtered));

        // 4. Dispatch a custom event to tell the Topbar to refresh its state
        window.dispatchEvent(new Event("notificationsUpdated"));
      }
    }

    // 1. Initialize/Ensure connection is active
    initializeChatHub(token).then(() => {
      // 2. Join the specific case room
      joinChatRoom(caseId.toString());

      // 3. Listen for regular messages
      onReceiveMessage((message) => {
        if (Number(message.caseId) !== Number(caseId)) return;

        const formattedMsg = msgFormatter(message);

        setMessages((prev: any) => {
          // Deduplicate based on PkChatMessage
          const exists = prev.some((m: any) =>
            m.pkChatMessage && Number(m.pkChatMessage) === Number(formattedMsg.pkChatMessage)
          );
          if (exists) return prev;
          return [...prev, formattedMsg];
        });

        // --- NEW: Clear notifications immediately for this case since chat is open ---
        const saved = localStorage.getItem("unread_notifications");
        if (saved) {
          const notifications = JSON.parse(saved);
          const filtered = notifications.filter((n: any) => Number(n.caseId) !== Number(caseId));
          localStorage.setItem("unread_notifications", JSON.stringify(filtered));
          window.dispatchEvent(new Event("notificationsUpdated"));
        }

        // --- NEW: Mark as Read immediately if we are looking at the screen ---
        // (Optional: Check document.hasFocus() or similar if needed)
        markAsRead(Number(caseId), Number(senderUserId));
      });

      // 4. Listen for Read Receipts (Real-time update of checks)
      onReceiveReadReceipt((data) => {
        if (Number(data.CaseId) === Number(caseId)) {
          setMessages((prevMessages) => {
            return prevMessages.map(msg => {
              // Update flags if they aren't already true
              const updated = { ...msg };
              if (data.IsUserRead) updated.isUserRead = true;
              if (data.IsProfessionalRead) updated.isProfessionalRead = true;
              if (data.IsAdminRead) updated.isAdminRead = true;
              if (data.IsCorporateRead) updated.isCorporateRead = true;
              return updated;
            });
          });
        }
      });

      // 4. Listen for SOS specifically within this room (optional, 
      // since Topbar also handles the global alert)
      // onReceiveSOS((data) => {
      //   const sosSystemMsg = {
      //     messageContent: "🚨 SOS: Admin assistance has been requested.",
      //     senderUserId: 0,
      //     messageType: "text",
      //     timestamp: new Date().toISOString(),
      //     link: `/chat/`
      //   };
      //   setMessages((prev) => [...prev, msgFormatter(sosSystemMsg)]);
      // });

      // 5. Listen for incoming calls
      onReceiveCallInvite((data) => {
        const initiator = data.initiatedBy || data.InitiatedBy;

        // Play Ringtone
        ringtoneSound.play().catch(e => console.warn("Audio play failed:", e));

        dispatch(
          setAlertData({
            alertMessage: `Incoming Call from ${initiator}`,
            alertVariant: "info",
            openAlert: true,
          })
        );
      });

      // 6. Listen for Call Ended event
      onReceiveCallEnded((data) => {
        const mid = data.messageId || data.MessageId;
        const dur = data.duration || data.Duration;

        setMessages((prev) =>
          prev.map((msg) => {
            if (Number(msg.pkChatMessage) === Number(mid)) {
              return {
                ...msg,
                isCallEnded: true,
                callDuration: dur,
                messageContent: `📞 Call ended. Duration: ${dur}`
              };
            }
            return msg;
          })
        );

        // Auto-close modal if this specific call ended
        setAgoraCallData(prev => {
          if (prev.open && Number(prev.messageId) === Number(mid)) {
            return { ...prev, open: false };
          }
          return prev;
        });
      });
    });

    handleFetchChatHistory();
    handleInitialLoad();

    return () => {
      leaveChatRoom(caseId.toString());
      offReceiveReadReceipt();
      offReceiveCallInvite();
      offReceiveCallEnded();
    };
  }, [caseId, senderUserId]);

  // 2. ADD THIS EFFECT TO SCROLL TO BOTTOM ON LOAD AND WHEN MESSAGES CHANGE
  React.useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]); // Runs every time messages array updates

  const handleSOSRequest = async () => {
    if (!caseId || !senderUserId) return;
    try {
      await sendSOSAlert(caseId.toString(), senderUserId);
      dispatch(setAlertData({
        alertMessage: "SOS Sent! Admins have been notified.",
        alertVariant: "success",
        openAlert: true,
      }));
    } catch (err) {
      console.error("SOS failed", err);
    }
  };

  const handleDeleteChat = async () => {
    if (!caseId) return;
    if (!window.confirm("Are you sure you want to delete this case? This action cannot be undone.")) {
      return;
    }

    try {
      dispatch(startLoading({ loading: true, loadtext: "Deleting case..." }));
      const res = await AdminApi.deleteCase(Number(caseId));
      if (res && res.success) {
        dispatch(setAlertData({
          alertMessage: "Case deleted successfully!",
          alertVariant: "success",
          openAlert: true,
        }));
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        dispatch(setAlertData({
          alertMessage: res?.message || "Failed to delete case.",
          alertVariant: "error",
          openAlert: true,
        }));
      }
    } catch (error: any) {
      console.error("Error deleting case:", error);
      dispatch(setAlertData({
        alertMessage: error.response?.data || "An error occurred while deleting case.",
        alertVariant: "error",
        openAlert: true,
      }));
    } finally {
      dispatch(stopLoading());
    }
  };

  const handleInitialLoad = async () => {
    const newArr: FormDataType[] = JSON.parse(
      JSON.stringify(MeetingCreationFormArr)
    );
    newArr[0].value =
      newArr[4].value = ` Meeting for ${selectedCase?.orderType} - ${selectedCase?.caseId} - ${selectedCase?.caseType}`; // Default topic and agenda
    newArr[3].value = "30"; // Default duration
    setFormData(newArr);
  };

  useEffect(() => {
    if (!analyserNode || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const bufferLength = analyserNode.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    const draw = () => {
      if (!isRecording) return;

      analyserNode.getByteTimeDomainData(dataArray);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.beginPath();

      for (let i = 0; i < bufferLength; i++) {
        const x = (i / bufferLength) * canvas.width;
        const y = (dataArray[i] / 128.0) * (canvas.height / 2);
        ctx.lineTo(x, y);
      }

      ctx.strokeStyle = "red";
      ctx.stroke();
      requestAnimationFrame(draw);
    };

    draw();
  }, [analyserNode, isRecording]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape")
        setSelectedDocument({
          docType: null,
          url: null,
        });
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleFetchChatHistory: () => void = async () => {
    const res = await ChatApi.fetchChatHistoryByCaseId({ caseId: caseId });
    if (res?.success) {
      let formatteRes: SingleMessageType[] = res?.data?.map((el: any) => {
        return msgFormatter(el);
      });
      if (myInfo.userType === "ADMIN") {
        formatteRes = formatteRes.filter(
          (el) => el.messageType !== "file" && el.messageType !== "audio"
        );
      }
      if (res?.data?.[0]?.caseTypeId) {
        const status = await StatusApi.caseStatus(res?.data?.[0]?.caseTypeId);
        setCaseStatus(status?.data);
      }
      setMessages(formatteRes);
    }
  };

  const handleSend = async () => {
    if (!caseId || !senderUserId) return;

    // If there's a recorded audio ready to be sent
    if (recordedAudioUrl && recordingChunks.length) {
      const blob = new Blob(recordingChunks, { type: "audio/webm" });
      const res = await ChatApi.handleUploadVoice({
        audioBlob: blob,
        caseId,
        senderUserId,
      });

      if (res?.success && res?.data?.url) {
        await sendMessage(
          caseId,
          senderUserId,
          "",
          "audio",
          `${process.env.REACT_APP_BASE_URL}${res.data.url}`,
          res?.data?.fileName || "voiceMessage.webm"
        );
      }

      // Cleanup after sending audio
      handleDeleteRecording();
      return;
    }

    // Otherwise, send text message
    if (input.trim()) {
      await sendMessage(caseId, senderUserId, input.trim(), "text", "", "");
      setInput("");
    }
  };

  const handleEnterPress: (event: any) => void = (event) => {
    if (event?.keyCode === 13 || event?.key === "Enter") {
      if (event.shiftKey) {
        // Shift+Enter: let the default behaviour add a newline
        return;
      }
      event.preventDefault();
      handleSend();
    }
  };

  const handleStartRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const chunks: Blob[] = [];
      setRecordingChunks([]);
      setRecordedAudioUrl(null);
      setMediaRecorder(recorder);
      setIsRecording(true);

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.push(e.data);
      };

      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);
        setRecordingChunks(chunks);
        setRecordedAudioUrl(url);
        setIsRecording(false);
      };

      // Setup AnalyserNode for waveform
      const audioContext = new AudioContext();
      const source = audioContext.createMediaStreamSource(stream);
      const analyser = audioContext.createAnalyser();
      source.connect(analyser);
      setAnalyserNode(analyser);

      recorder.start();
    } catch (error) {
      console.error("Recording failed", error);
    }
  };

  const handleStopRecording = () => {
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const handleDeleteRecording = () => {
    setRecordedAudioUrl(null);
    setRecordingChunks([]);
    setMediaRecorder(null);
  };

  const handleAttachmentUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    //show loader or disable input while uploading
    dispatch(startLoading({ loading: true, loadtext: "Uploading..." }));

    const files = event.target.files;
    if (!files || !caseId || !senderUserId) return;

    try {
      const fileArray = Array.from(files);

      const oversizedFiles = fileArray.filter(f => f.size > MAX_FILE_SIZE_BYTES);

      if (oversizedFiles.length > 0) {
        const names = oversizedFiles.map(f => f.name).join(", ");

        dispatch(
          setAlertData({
            alertMessage: `The following files are too large: ${names}. The maximum size is ${MAX_FILE_SIZE_MB}MB.`,
            alertVariant: "error",
            openAlert: true,
          })
        );
        return;
      }

      // 2. Process Uploads
      const uploadPromises = fileArray.map(async (file) => {
        const res = await ChatApi.uploadAttachment({
          attachmentBlob: file,
          caseId: caseId,
        });

        if (res?.success && res?.data?.url) {
          await sendMessage(
            caseId,
            senderUserId,
            "",
            "file",
            `${process.env.REACT_APP_BASE_URL}${res.data.url}`,
            res?.data?.fileName
          );
        }
      });

      await Promise.all(uploadPromises);
    } catch (err) {
      console.error("One or more attachment uploads failed", err);
    } finally {
      dispatch(stopLoading());
      // Clear input so user can select the same files again if needed
      event.target.value = "";
    }
  };

  const downloadImage = async (url: string, fileName: string) => {
    try {
      const response = await fetch(url, {
        mode: "cors",
        cache: "no-cache",
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file.");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      alert("Download failed. Please try again.");
    }
  };

  const handleCloseCase = async () => {
    setOpenStatusModal(true);
  };

  const handleReOpenCase = async () => { };

  const handleStatusUpdate = async (selectedStatus: any) => {
    try {
      dispatch(startLoading({ loading: true, loadtext: "Updating Status..." }));

      // Here you would call your API to update the case status
      // const res = await CaseApi.updateCaseStatus({
      //   caseId: selectedCase?.caseId,
      //   statusId: selectedStatus.pkProcessingStatus
      // });

      // Send a message to the chat about the status update
      if (selectedCase?.caseId && senderUserId) {
        await sendMessage(
          selectedCase.caseId,
          senderUserId,
          `Case status updated to: ${selectedStatus.statusName}.`,
          "text",
          "",
          ""
        );
      }

      dispatch(
        setAlertData({
          alertMessage: `Case status updated to ${selectedStatus.statusName}`,
          alertVariant: "success",
          openAlert: true,
        })
      );

      dispatch(stopLoading());
    } catch (error) {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Failed to update case status",
          alertVariant: "error",
          openAlert: true,
        })
      );
    }
  };
  const handleCallConnection = async (isJoinOnly: boolean = false) => {
    dispatch(startLoading({ loading: true, loadtext: isJoinOnly ? "Joining Agora Call..." : "Connecting Agora Call..." }));
    const res = await MeetingApi.AgoraConferenceCall({
      caseId: selectedCase?.caseId?.toString(),
      isJoinOnly: isJoinOnly
    });
    console.log("res", res);
    if (res?.success) {
      dispatch(stopLoading());
      setAgoraCallData({
        open: true,
        appId: res.appId,
        channelName: res.channelName,
        token: res.token,
        uid: res.uid,
        messageId: res.messageId,
        participants: res.participants || []
      });
    } else {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Failed to initiate call.",
          alertVariant: "error",
          openAlert: true,
        })
      );
    }
  };

  const handleScheduleMeet: () => void = async () => {
    dispatch(startLoading({ loading: true, loadtext: "Scheduling Meeting..." }));
    if (!caseId || !senderUserId) return;

    const validation = ValidateFormData(formData);
    setFormData(validation.formData);
    if (!validation.errorCheck && selectedCase?.caseId) {
      dispatch(
        startLoading({ loading: true, loadtext: "Scheduling Meeting..." })
      );

      const date = formData.find((el) => el.id === "startAt")?.value;
      const time = formData.find((el) => el.id === "startTime")?.value;
      const combinedDateTime = dayjs(
        `${date} ${time}`,
        "YYYY-MM-DD hh:mm A"
      ).format("YYYY-MM-DD hh:mm A");
      const payload: any = {
        caseId: selectedCase?.caseId?.toString(),
        topic: formData.find((el) => el.id === "topic")?.value,
        startAt: combinedDateTime,
        durationInMinutes: formData.find((el) => el.id === "durationInMinutes")
          ?.value,
        agenda: formData.find((el) => el.id === "agenda")?.value,
      };
      const res = await MeetingApi.ScheduleMeeting(payload);
      if (res?.success) {
        await sendMessage(
          selectedCase?.caseId,
          senderUserId ?? 0,
          `Meeting successfully scheduled at ${dayjs(payload.startAt).format(
            "YYYY-MM-DD, hh:mm A"
          )}`,
          "text",
          "",
          ""
        );
        dispatch(
          setAlertData({
            alertMessage: "Meeting scheduled successfully.",
            alertVariant: "success",
            openAlert: true,
          })
        );
        dispatch(stopLoading());
        setOpenMoadal(false);
        handleInitialLoad();
      } else {
        dispatch(stopLoading());
      }
    }
  };

  // 2. Add the submit handler
  const handleSendPaymentLink = async () => {
    if (!amount || isNaN(Number(amount))) return;

    dispatch(startLoading({ loading: true, loadtext: "Generating Payment Link..." }));

    setIsGeneratingLink(true);
    try {
      const response = await PaymentApi.generatePaymentLinkForCase({
        caseId: caseId,
        amount: Number(amount),
      });

      const paymentLink = response.data.paymentLink;

      // We send a specific prefix "💳 PAYMENT_REQUEST|" so the UI knows to render a button
      await sendMessage(
        caseId ?? 0,
        myInfo.id ?? 0,
        `PAYMENT_REQUEST|${amount}|${paymentLink}`,
        "text"
      );

      setPaymentModalOpen(false);
      setAmount("");
    } catch (error) {
      console.error("Failed to generate payment link", error);
    } finally {
      dispatch(stopLoading());
      setIsGeneratingLink(false);
    }
  };

  const modalBody = (
    <Box
      sx={{
        ...sxMain,
        backgroundColor: "common.white",
        boxShadow: "0px 0px 6px #00000029",
        borderRadius: 1.25,
        width: "50%",
      }}
    >
      {
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            ...sxHead,
            justifyContent: "space-between",
            height: "3rem",
          }}
        >
          <Typography
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              "&>svg": {
                mr: 1,
              },
            }}
          >
            Schedule Meetinng
          </Typography>
          {
            <IconButton onClick={() => setOpenMoadal(false)}>
              <ImgPath.CloseIcon />
            </IconButton>
          }
        </Box>
      }
      <Box
        sx={{
          height: "calc(100% - 6rem)",
          p: 2,
        }}
      >
        <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
          {formData.map((el: FormDataType) => (
            <Grid key={el.id} size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}>
              {commonFormSwitch({
                formObj: el,
                onChange: (data) =>
                  setFormData(HandleFormChange(data, formData)),
              })}
            </Grid>
          ))}
        </Grid>
      </Box>
      {
        <Box
          sx={{
            px: 2,
            mb: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            height: "3rem",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleScheduleMeet()}
          >
            Schedule
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setOpenMoadal(false)}
            sx={{ ml: 1, borderColor: "primary.main", color: "primary.main" }}
          >
            Cancel
          </Button>
        </Box>
      }
    </Box>
  );

  const getInitials: (orderType: string) => string = (orderType) => {
    if (!orderType) return "";
    const words = orderType.split(" ");
    let initials = "";
    for (let i = 0; i < words.length && i < 2; i++) {
      initials += words[i].charAt(0).toUpperCase();
    }
    return initials;
  };

  const handleEndCall = async (duration: string) => {
    if (!agoraCallData.messageId) return;
    try {
      await MeetingApi.EndAgoraConferenceCall({
        messageId: agoraCallData.messageId,
        duration: duration
      });
    } catch (e) {
      console.error("Failed to end call session", e);
    }
  };

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#efeae2" }}>
      {/* Modals remain at the top level */}
      <Modal open={openModal} onClose={() => setOpenMoadal(false)}>{modalBody}</Modal>
      <StatusUpdateModal
        open={openStatusModal}
        onClose={() => setOpenStatusModal(false)}
        caseStatus={caseStatus}
        onStatusUpdate={handleStatusUpdate}
        currentCaseId={selectedCase?.caseId}
      />

      {/* VERSION 4: LIGHTWEIGHT WHITE GLASS HEADER */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        px: 3,
        py: 2,
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
        flexShrink: 0,
        zIndex: 11,
        position: "sticky",
        top: 0,
      }}>
        <Avatar
          alt={selectedCase?.orderType}
          sx={{
            width: 44,
            height: 44,
            background: "linear-gradient(135deg, #1a237e, #3949ab)",
            color: "#fff",
            fontWeight: 800,
            fontSize: "1rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
          }}
        >
          {getInitials(selectedCase?.orderType ?? "")}
        </Avatar>
        <Box sx={{ ml: 2, flexGrow: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "#1a237e", lineHeight: 1.2 }}>
            {selectedCase?.orderType || "Conversation"}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.primary", opacity: 0.7, fontWeight: 600 }}>
            {selectedCase?.caseNumber ? `#${selectedCase.caseNumber}` : `ID: ${selectedCase?.caseId}`}
          </Typography>
        </Box>
        <Stack direction="row" spacing={0.5}>
          {myInfo.userType === "PROFESSIONAL" && (
            <>
              <IconButton sx={{ color: "#4a4c96ff" }} onClick={() => setOpenMoadal(true)}><ImgPath.CalenderIcon /></IconButton>
              <IconButton sx={{ color: "#4a4c96ff" }} onClick={() => handleCallConnection(false)}><ImgPath.CallIcon /></IconButton>
            </>
          )}
          {(myInfo.userType === "USER" || myInfo.userType === "CORPORATEUSER" || myInfo.userType === "NRIUSER") && (
            <>
              <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => handleCallConnection(false)}><ImgPath.CallIcon /></IconButton>
            </>
          )}

          {(myInfo.userType === "PROFESSIONAL" || myInfo.userType === "ADMIN") && (
            <>
              <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={handleCloseCase}><ImgPath.TaskAltRoundedIcon /></IconButton>
              <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={handleReOpenCase}><ImgPath.ReplayRoundedIcon /></IconButton>
            </>
          )}
          {(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN") && (
            <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setPaymentModalOpen(true)}><CurrencyRupee /></IconButton>
          )}
          {(myInfo.userType === "USER" || myInfo.userType === "CORPORATEUSER" || myInfo.userType === "NRIUSER") && (
            <IconButton size="small" sx={{ color: "#4a4c96ff", backgroundColor: alpha("#fff", 0.15), "&:hover": { backgroundColor: alpha("#fff", 0.25) }, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }} onClick={handleSOSRequest}>
              <Campaign sx={{ fontSize: 20 }} />
            </IconButton>
          )}
          {myInfo?.userType === "SUPERADMIN" && (
            <IconButton
              size="small"
              title="Delete Chat"
              sx={{
                color: "#d32f2f",
                "&:hover": { backgroundColor: "rgba(211, 47, 47, 0.08)" }
              }}
              onClick={handleDeleteChat}
            >
              <DeleteForeverRounded />
            </IconButton>
          )}
          {/* <IconButton size="small" sx={{ color: "#4a4c96ff" }}><MoreVert /></IconButton> */}
        </Stack>
      </Box>

      {/* VERSION 4: LIGHTWEIGHT AZURE MESSAGE AREA */}
      <Box
        ref={scrollRef}
        sx={{
          flex: 1,
          overflowY: "auto",
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          backgroundColor: "#f0f7ff", // Lightweight Azure
          position: "relative",
          backgroundImage: `linear-gradient(rgba(240, 247, 255, 0.95), rgba(240, 247, 255, 0.95)), url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")`,
          backgroundRepeat: "repeat",
          backgroundSize: "400px",
          backgroundAttachment: "fixed",
        }}>
        <Box sx={{ alignSelf: 'center', my: 2 }}>
          <Typography sx={{
            fontSize: '0.75rem',
            fontWeight: 700,
            color: "text.primary",
            backgroundColor: "rgba(255,255,255,0.8)",
            backdropFilter: "blur(5px)",
            px: 3,
            py: 0.75,
            borderRadius: 5,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            border: "1px solid rgba(0,0,0,0.05)",
            opacity: 0.8
          }}>
            🔒 This conversation is secured with end-to-end encryption.
          </Typography>
        </Box>

        {messages?.length > 0 ? (
          messages.map((msg, index) => {
            if (msg.messageType === "system") {
              return (
                <Box key={index} sx={{
                  alignSelf: "center",
                  my: 1,
                  maxWidth: "85%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}>
                  <Box sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.06)",
                    backdropFilter: "blur(5px)",
                    px: 2.5,
                    py: 0.75,
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    border: "1px solid rgba(0,0,0,0.05)",
                    textAlign: "center",
                  }}>
                    <Typography variant="body2" sx={{
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      color: "text.primary",
                      opacity: 0.8,
                      lineHeight: 1.4,
                    }}>
                      {msg.messageContent}
                    </Typography>
                  </Box>
                  <Typography variant="caption" sx={{ mt: 0.5, fontSize: "0.6rem", fontWeight: 700, color: "text.primary", opacity: 0.5 }}>
                    {dayjs(msg.timestamp).format("hh:mm A, DD-MM-YYYY")}
                  </Typography>
                </Box>
              );
            }

            const isMe = msg.senderUserId === myInfo.id;
            const isPayment = msg.messageContent?.startsWith("PAYMENT_REQUEST|");
            let payAmount = "", payUrl = "";
            if (isPayment) {
              const parts = msg.messageContent.split("|");
              payAmount = parts[1]; payUrl = parts[2];
            }

            return (
              <Box key={index} sx={{
                alignSelf: isMe ? "flex-end" : "flex-start",
                maxWidth: "75%",
                mb: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: isMe ? "flex-end" : "flex-start",
              }}>
                {/* Sender Name for incoming messages */}
                {!isMe && msg.senderUser?.userName && (
                  <Typography variant="caption" sx={{ mb: 0.5, ml: 1, fontWeight: 700, color: "#1a237e", fontSize: "0.7rem", opacity: 0.8 }}>
                    {msg.senderUser.firstName} • {formatUserType(msg.senderUser.userType)}
                  </Typography>
                )}

                <Box sx={{
                  background: isMe && !isPayment
                    ? "linear-gradient(135deg, #1a237e 0%, #283593 100%)"
                    : (isPayment ? "#fff" : "#fff"),
                  color: (isMe && !isPayment) ? "#fff" : "text.primary",
                  px: 2, py: 1.5,
                  borderRadius: isMe ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
                  boxShadow: isMe ? "0 4px 12px rgba(26, 35, 126, 0.15)" : "0 2px 8px rgba(0,0,0,0.05)",
                  border: isMe ? "none" : "1px solid rgba(0,0,0,0.04)",
                  position: "relative",
                  maxWidth: "85%",
                }}>
                  {isPayment ? (
                    <Box sx={{ minWidth: "220px" }}>
                      <Stack direction="row" alignItems="center" spacing={1} mb={1.5}>
                        <Box sx={{ p: 1, bgcolor: alpha("#1a237e", 0.1), borderRadius: 1.5 }}>
                          <CurrencyRupee sx={{ color: '#1a237e', fontSize: 20 }} />
                        </Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#1a237e" }}>Payment Request</Typography>
                      </Stack>
                      <Typography variant="body2" sx={{ mb: 2, color: "text.primary", fontWeight: 500 }}>
                        The professional has requested a payment of <b style={{ color: "#1a237e", fontSize: '1rem' }}>₹{payAmount}</b>
                      </Typography>
                      {!isMe ? (
                        <Button
                          variant="contained"
                          size="large"
                          fullWidth
                          href={payUrl}
                          target="_blank"
                          sx={{
                            background: "linear-gradient(90deg, #1a237e, #283593)",
                            color: "white",
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 700,
                            boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)"
                          }}
                        >
                          Complete Payment
                        </Button>
                      ) : (
                        <Box sx={{ pt: 1, borderTop: "1px solid rgba(0,0,0,0.05)", textAlign: 'right' }}>
                          <Typography variant="caption" sx={{ fontWeight: 700, color: "#1a237e", cursor: 'pointer' }} onClick={() => window.open(payUrl, '_blank')}>View Receipt Link →</Typography>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <>
                      {msg.messageType === "audio" ? <AudioComponent message={msg} /> :
                        msg.messageType === "call" ? (
                          <Box sx={{ p: 2, }}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: msg.senderUserId === myInfo.id ? "white" : "text.primary" }}>
                              {msg.isCallEnded ? `📞 Call ended. Duration: ${msg.callDuration}` : (msg.messageContent || "Incoming Call Request")}
                            </Typography>
                            {!msg.isCallEnded ? (
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<Call />}
                                onClick={() => handleCallConnection(true)}
                                sx={{
                                  borderRadius: 20,
                                  backgroundColor: msg.senderUserId === myInfo.id ? "#fff" : "primary.main",
                                  color: msg.senderUserId === myInfo.id ? "primary.main" : "#fff",
                                  "&:hover": { backgroundColor: msg.senderUserId === myInfo.id ? "#eee" : "primary.dark" }
                                }}
                              >
                                Join Call
                              </Button>
                            ) : (
                              <Typography variant="caption" sx={{ color: msg.senderUserId === myInfo.id ? "rgba(255,255,255,0.7)" : "text.secondary" }}>Session Closed</Typography>
                            )}
                          </Box>
                        ) :
                          msg.messageType === "file" ? <AttachmentComponent message={msg} downloadImage={downloadImage} setSelectedDocument={({ attachmentUrl, docType }) =>
                            setSelectedDocument({
                              url: attachmentUrl,
                              docType: docType,
                            })} /> :
                            <Typography
                              variant="body2"
                              sx={{
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                                color: msg.senderUserId === myInfo.id ? "white" : "black",
                                whiteSpace: "pre-wrap",
                                fontWeight: 500,
                                lineHeight: 1.5,
                              }}
                            >
                              {msg.messageContent}
                            </Typography>
                      }
                    </>
                  )}
                </Box>
                <Typography variant="caption" sx={{ mt: 0.5, px: 1, fontSize: "0.65rem", fontWeight: 700, color: "text.primary", opacity: 0.6 }}>
                  {dayjs(msg.timestamp).format("hh:mm A, DD-MM-YYYY")}
                </Typography>
              </Box>
            );
          })
        ) : <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><NoData cstmMsg="Your conversation will appear here." /></Box>}

        {/* Spacer for Mobile Fixed Input */}
        <Box sx={{ height: { xs: "90px", md: "10px" }, flexShrink: 0 }} />
      </Box>

      {/* RECORDING PREVIEW */}
      {isRecording && (
        <Box sx={{ p: 1, backgroundColor: "#fff", borderTop: "1px solid #ccc" }}>
          <canvas ref={canvasRef} width={300} height={40} style={{ margin: "0 auto", display: "block" }} />
        </Box>
      )}

      {recordedAudioUrl && (
        <Box sx={{ display: "flex", alignItems: "center", p: 1, backgroundColor: "#fff", borderTop: "1px solid #ccc" }}>
          <audio controls src={recordedAudioUrl} style={{ height: 30, flex: 1 }} />
          <IconButton onClick={handleDeleteRecording} color="error"><DeleteForeverRounded /></IconButton>
        </Box>
      )}

      {/* VERSION 4: CLEAN WHITE PILL INPUT ISLAND */}
      <Box sx={{
        px: 3,
        py: 2,
        backgroundColor: "rgba(240, 247, 255, 0.8)", // Lightweight Azure tint
        backdropFilter: "blur(10px)",
        borderTop: "1px solid rgba(0,0,0,0.04)",
        position: { xs: "fixed", md: "relative" },
        bottom: 0, left: 0, right: 0, zIndex: 12,
        pb: "env(safe-area-inset-bottom, 20px)"
      }}>
        <Paper elevation={0} sx={{
          display: "flex",
          alignItems: "flex-end",
          p: 0.75,
          backgroundColor: "#fff",
          borderRadius: "24px",
          border: "1px solid rgba(26, 35, 126, 0.15)",
          transition: "all 0.3s ease",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          "&:focus-within": {
            boxShadow: "0 8px 25px rgba(26, 35, 126, 0.12)",
            borderColor: "#1a237e",
          }
        }}>
          <IconButton component="label" sx={{ color: "#1a237e" }}>
            <AttachFile sx={{ transform: "rotate(45deg)" }} />
            <input type="file" hidden multiple onChange={handleAttachmentUpload} />
          </IconButton>

          <InputBase
            value={input}
            multiline
            maxRows={6}
            sx={{
              ml: 1,
              flex: 1,
              fontSize: "15px",
              fontWeight: 500,
              py: 1,
            }}
            placeholder="Type your message..."
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => handleEnterPress(e)}
          />

          <Stack direction="row" spacing={0.5} sx={{ mr: 0.5, mb: 0.2 }}>
            <IconButton
              onClick={isRecording ? handleStopRecording : handleStartRecording}
              sx={{
                color: isRecording ? "#ff1744" : "#1a237e",
                backgroundColor: isRecording ? alpha("#ff1744", 0.1) : "transparent",
                "&:hover": { backgroundColor: isRecording ? alpha("#ff1744", 0.2) : alpha("#1a237e", 0.05) }
              }}
            >
              <Mic />
            </IconButton>

            <IconButton
              onClick={handleSend}
              disabled={!input.trim() && !recordedAudioUrl}
              sx={{
                backgroundColor: "#1a237e",
                color: "#fff",
                "&:hover": { backgroundColor: "#283593" },
                "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" },
                width: 40,
                height: 40,
                boxShadow: input.trim() ? "0 4px 12px rgba(26, 35, 126, 0.3)" : "none"
              }}
            >
              <Send sx={{ fontSize: 20, ml: 0.5 }} />
            </IconButton>
          </Stack>
        </Paper>
      </Box>

      {/* Fullscreen Previews & Payment Dialog (Keep existing logic) */}
      {/* Payment Modal */}
      <Dialog open={paymentModalOpen} onClose={() => {
        setPaymentModalOpen(false);
        setBaseAmount("");
        setAmount("");
      }}>
        <DialogTitle>Send Payment Link</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Enter the base amount. The system will automatically add <strong>18% GST</strong> to calculate the total.
          </Typography>

          <TextField
            autoFocus
            margin="dense"
            label="Base Amount"
            type="number"
            fullWidth
            variant="outlined"
            value={baseAmount}
            onChange={(e) => {
              const val = e.target.value;
              setBaseAmount(val);
              if (val && !isNaN(Number(val))) {
                const total = (Number(val) * 1.18).toFixed(2);
                setAmount(total);
              } else {
                setAmount("");
              }
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />

          {baseAmount && !isNaN(Number(baseAmount)) && (
            <Box sx={{ mt: 2, p: 2, bgcolor: "#f8f9fa", borderRadius: 1, border: "1px dashed #ccc" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body2">Base Amount:</Typography>
                <Typography variant="body2" fontWeight="500">₹{Number(baseAmount).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body2">GST (18%):</Typography>
                <Typography variant="body2" fontWeight="500">₹{(Number(baseAmount) * 0.18).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, pt: 1, borderTop: "1px solid #ddd" }}>
                <Typography variant="subtitle2" fontWeight="bold">Total Amount:</Typography>
                <Typography variant="subtitle2" fontWeight="bold" color="primary.main">₹{amount}</Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPaymentModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleSendPaymentLink}
            variant="contained"
            disabled={isGeneratingLink || !amount}
          >
            {isGeneratingLink ? "Generating..." : "Send Link"}
          </Button>
        </DialogActions>
      </Dialog>
      {agoraCallData.open && (
        <AgoraCall
          appId={agoraCallData.appId}
          channelName={agoraCallData.channelName}
          token={agoraCallData.token}
          uid={agoraCallData.uid}
          onClose={() => setAgoraCallData({ ...agoraCallData, open: false })}
          onEndCall={handleEndCall}
        />
      )}
    </Box>
  );
};

export default SingleChatScreen1;
const sxHead = {
  backgroundColor: "primary.main",
  px: 2,
  "& >p:first-of-type": {
    color: "white",
  },
  "& >button": {
    color: "white",
  },
};
const sxMain = {
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  transform: `translate(-${50}%, -${50}%)`,
  position: "absolute",
  outline: "none",
  // overflow: "auto",
  borderRadius: 1.25,
};
